import {
  Component,
  OnInit,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { ReportService, Combo2Service, ExcelService, PurchaseOrderService } from "../../../../services/index";
import * as _ from "lodash";

@Component({
  selector: "sampleSwatchPendingReport",
  templateUrl: "sampleSwatchPendingReport.html",
})
export class sampleSwatchPendingReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  order_no: any = "";
  loading = false;
  designType = [];
  data: any = {};
  detail: any = {};
  row = [];
  backbutExists: boolean = false;
filter: any = {
    finyear: "",
    fin_id: "",
    season_id: "",
    season: "",
    from_date: "",
    to_date: "",
    groupby: "entry_wise",
    party_id: "",
    // po_id: "",
    party_code: "",
    po_no: "",
    book_no: "",
    po_date: "",
    po_from_date: "",
    po_to_date: "",
     style: [],
    variety: [],
    design_no: [],
    vendor_name: [],
    vendor_design: [],
    order_no: "",
    view_type: "Po" 
  };
  styleList: any[] = ["RR FORMAL", "RR CASUAL"];
  varietyList: any[] = ["PLAIN", "SV", "B.CHECKS", "B.STRIPES", "INDIGO PLAIN"];
  designNoList: any[] = [];
  vendorList: any[] = []; // This will contain {party_id, party_code/name}
  vendorDesignList: any[] = [];
  poNoList: any[] = [];
  orderNoList: any[] = [];
  gridOptions: any;
  menu: any;
  exceldata: any;
  columnDefs: any[];
  isLoadMask: Promise<any>;
  loadingIndicator: boolean = true;
  columns = [];
  rowData: any[] = [];
  orderList: any = [];
  finyearList = [];
  toggleCol = [];
  @ViewChild("tabContent") tabContent;
  @ViewChild("entryContainer") entryContainer;
  @ViewChild("listContainer") listContainer;
  seasonList: any = [];
  constructor(
    private service: ReportService,
    private dp: DatePipe,
    private combo2Service: Combo2Service,
    public datePipe: DatePipe,
    private excelService: ExcelService,
     private poservice: PurchaseOrderService,
  ) {
    const date = new Date();
    let oneMnthDate =
      date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
    let oneMonthBeforeDate = new Date(oneMnthDate);
    this.filter.from_date = oneMonthBeforeDate;
    this.filter.to_date = date;
    // this.filter.po_from_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    // this.filter.po_to_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
  }
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "party_id",
    orderDir: "ASC",
  };
  printConfig: any = {
    title: "BULK PENDING",
    columns: [],
    rows: [],
  };

  ngOnInit(): void {
    this.codelist();
    this.getColumns();
    //   this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

    codelist() {
    this.poservice.codelist({}).then((res: any) => {
      this.vendorList = res.data;
    });
  }

    coreGangList() {
    let params = {
      party_id: this.filter.party_id,
      page: 'RR Report'
    };
    let that = this;
    that.poservice.coreGangList(params).then((res: any) => {
      that.vendorDesignList = res.coreList;
    })
  }
  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.pageCallback({ offset: 0 });
  }
  applyFilter() {
    this.sampleSwatchPending();
  }
  clearFilter(){
       this.filter.style = [];
    this.filter.variety  = []
    this.filter.design_no = []
    this.filter.vendor_name = [];
    this.filter.vendor_design = [];
     this.filter.party_id = [];
     this.filter.po_no = "";
         this.sampleSwatchPending();

  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }
  onCellClick(event) {
    if (this.filter.groupby == "style") {
      this.filter.party_id = event.row.party_id;
      this.filter.party_code = event.row.party_code;
      this.filter.style = event.row.style;
      this.filter.groupby = "variety";
    }
    else if (this.filter.groupby == "variety") {
      this.filter.party_id = event.row.party_id;
      this.filter.party_code = event.row.party_code;
      this.filter.po_date = event.row.po_date;
      this.filter.type = event.row.type;
      this.filter.book_no = event.row.book_no;
      this.filter.groupby = "party";
    }
    else if (this.filter.groupby == "party") {
      this.filter.party_id = event.row.party_id;
      this.filter.po_date = event.row.po_date;
      this.filter.groupby = "design";
    }
    else if (this.filter.groupby == "design") {
      this.filter.party_id = event.row.party_id;
      this.filter.po_date = event.row.po_date;
      this.filter.design_no = event.row.fabric_design;
      this.filter.vend_des = event.row.design_no
      this.filter.groupby = "entry_wise";
    
    }
 



    this.sampleSwatchPending();
  }
 
  sampleSwatchPending() {
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.filter.po_from_date =
      this.datePipe.transform(this.filter.po_from_date, "yyyy-MM-dd");

    this.filter.po_to_date = this.datePipe.transform(
      this.filter.po_to_date,
      "yyyy-MM-dd"
    );
    this.loadingIndicator = true;
    let params = {
      filter: JSON.stringify(this.filter),
      report_type: "bulk",
    };
    let data = [];
    this.isLoadMask = this.service
      .sampleSwatchPending(params)
      .then((res: any) => {
        if (res.success) {
          this.loadingIndicator = false;
          this.page.count = res.totCnt;
          this.orderList = res.data;
          if (this.filter.groupby == 'entry_wise') {
            let party: any;
            // this.orderList = [];
            let temp_list = [];
            // party = Object.values(_.groupBy(res.data, 'book_no'));
            // party = _.groupBy(res.data, 'po_no');
            // console.log(party,'po_no')
            // for (const key in party) {
            //   temp_list.push(party[key])
            // }
            // temp_list.forEach((e, i) => {
            //   e.forEach((el, ind) => {
            //     if (ind == e.length - 1)
            //       e.push({})
            //   })
            // });
            // temp_list.forEach(e => {
            //   e.forEach((el, ind) => {
            //     this.orderList.push(el)
            //   })
            // });
            // console.log(this.orderList)
          }
          this.gridOptions = {
            cols: res.cols,
            columns: res.columns,
            data: this.orderList,
            loading: false,
          };
          // this.filter.order_no = "";
          this.exceldata = this.getData(res.columns, res.data);
        }
        this.backbutton();
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
      });
  }
  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
  onbackbutton() {
    if (this.filter.groupby == "variety") {
      this.filter.groupby = "style";
      this.filter.party_id = "";
    }
    else if (this.filter.groupby == "party") {
      this.filter.type = '';
      this.filter.groupby = "variety";
    }
    else if (this.filter.groupby == "design") {
      this.filter.groupby = "party";
      this.filter.party_id = "";
      this.filter.po_date = "";
    }
    else if (this.filter.groupby == "entry_wise") {
      this.filter.design_no = '';
      this.filter.groupby = "design";
    }
 

    this.sampleSwatchPending();
  }
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.sampleSwatchPending();
  }

  backbutton() {
    if ($(".data-history-btn").length) {
      this.backbutExists = false;
    } else {
      this.backbutExists = true;
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/POStatusReports/sampleSwatchPendingReport/sampleSwatchPendingReport.ts